import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getMasterReport=({
    date,
    smasterName,
    type
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.MASTER_REPORT_START,
    })
    const options={
        url:`${api}/reports/daily/masters?smasterName=${smasterName}&type=${type}&date=${date}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.MASTER_REPORT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.MASTER_REPORT_FAIL,
                payload:getMessage(error)
            }))
}